import { PayloadAction } from "@reduxjs/toolkit";
import { PricingState } from "../pricingSlice";

export interface ToggleFilterItemPayload {
  filterId: string
  itemId: string
}

export interface SetFilterItemPayload {
  filterId: string
  itemId: string
  value: boolean
}

export interface SetAllFilterItemsPayload {
  filterId: string
  value: boolean
}

export interface UpdateContractFunnelItemPayload {
  contractFunnelId: string
  contractIdentifier?: string
  itemId: string
  type: 'variable' | 'fee'
  newValue: number
}

export interface UpdateAllContractFunnelsItemPayload {
  itemId: string
  type: 'variable' | 'fee'
  newValue: number
}

export const filterReducers = {
  toggleFilterItem: (state: PricingState, action: PayloadAction<ToggleFilterItemPayload>) => {
    const { filterId, itemId } = action.payload
    for (const filter of state.filters) {
      if (filter.title === filterId) {
        const item = filter.items.find(item => item.id === itemId)
        if (item) {
          item.value = !item.value
        }
        break
      }
    }
  },

  resetFilters: (state: PricingState) => {
    state.filters.forEach(filter => {
      filter.items.forEach(item => {
        item.value = false
      })
    })
  },

  enableAllFilters: (state: PricingState) => {
    state.filters.forEach(filter => {
      filter.items.forEach(item => {
        item.value = true
      })
    })
  },

  setFilterItem: (state: PricingState, action: PayloadAction<SetFilterItemPayload>) => {
    const { filterId, itemId, value } = action.payload
    for (const filter of state.filters) {
      if (filter.title === filterId) {
        const item = filter.items.find(item => item.id === itemId)
        if (item) {
          item.value = value
        }
        break
      }
    }
  },

  setAllFilterItems: (state: PricingState, action: PayloadAction<SetAllFilterItemsPayload>) => {
    const { filterId, value } = action.payload
    for (const filter of state.filters) {
      if (filter.title === filterId) {
        filter.items.forEach(item => {
          item.value = value
        })
        break
      }
    }
  }
};
